import { NVLoadingPlaceholderPanel } from 'shared/components/nv-loading-placeholder';
import { css } from '@emotion/react';


const AnalyticsLoader = () => {
  const styles = css`
    max-width: 1024px;
  `;

  return (
    <div css={styles} className='d-flex flex-direction-row justify-content-center pt-6'>
      <NVLoadingPlaceholderPanel height='140px' width='240px' />
      <NVLoadingPlaceholderPanel height='140px' width='240px' />
      <NVLoadingPlaceholderPanel height='140px' width='240px' />
      <NVLoadingPlaceholderPanel height='140px' width='240px' />
    </div>
  );
};

export default AnalyticsLoader;
